<template>

  <div class="dlnkmessages_new_message_components">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>


    <div class="modal fade text-body" id="new_message_modal" tabindex="-1" role="dialog" aria-labelledby="newMailLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-primary" id="newMailLabel">
              Rédiger un message
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form id="message_form"
                @submit.prevent="send_message"
                method="post"
                class="needs-validation" novalidate>

            <div class="modal-body">

              <div v-if="group_id.length == 0" class="form-group">
                <label>Destinataire :</label>

                <div v-for="recipient in recipients" :key="recipient.id" class="dlnkmessages-search_result m-1 p-1"
                     @click="add_recipient(recipient.id, recipient.name, recipient.type)">
                  <img :src="recipient.photo_url" class="avatar avatar-circle" alt="Photo du membre">
                  {{ recipient.name }}
                </div>

                <div v-for="recipient in to_recipients" :key="recipient.id" class="dlnkmessages_recipient mt-1"
                     @click="remove_recipient(recipient.id, recipient.type)">
                  <span class="dlnkmessages_recipient_name">{{ recipient.name }}</span>
                  <span class="dlnkmessages_recipient_cross ml-2 font-weight-bolder fas fa-times text-danger">
<!--                           data-type="${type}" data-id="${id}"-->
                    <!--                           onclick="DlnkMessages.remove_recipient(event);"> -->
                  </span>
                </div>

                <input type="hidden" name="message[to_members]" id="dlnkmessages_to_members" v-model="to_members">
                <input type="hidden" name="to_groups" id="dlnkmessages_to_groups" v-model="to_groups">
                <input type="text" class="form-control form-control-sm dlnkmessages-recipients mt-2" name="to"
                       v-model="recipient"
                       @keyup="find_recipients()">

                <div id="dlnkmessages_recipient_search_result"></div>

              </div>

              <div class="form-group">
                <label for="new_subject">Sujet</label>
                <input type="text" class="form-control form-control-sm" v-model="new_subject"
                       v-bind:class="{ 'is-invalid': subject_invalid }"
                       id="new_subject" minlength="1" required>
                <div class="invalid-feedback">
                  Veuillez saisir le sujet du message (taille comprise entre 3 et 255 caractères)
                </div>
              </div>

              <div class="form-group">
                <label for="new_message">Message</label>
                <ckeditor id="new_message" :editor="editor" v-model="new_message" :config="editor_config"
                          name="new_message"></ckeditor>

                <div class="invalid-feedback">
                  Veuillez saisir le message (au moins 3 caratères)
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fas fa-times"></i>&nbsp;Annuler
              </button>
              <button @click="send_message()" type="button" class="btn btn-primary" name="send_message">
                <i class="fas fa-paper-plane"></i>&nbsp;Envoyer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  props: ['subject', 'reply_recipient', 'group_id'],
  data: function () {
    return {
      message_type: "",
      message: "",
      recipients: [],
      recipient: "",
      new_subject: "",
      subject_invalid: false,
      new_message: "",
      to_members: "",
      to_groups: "",
      to_recipients: [],
      editor: ClassicEditor,
      editor_config: {
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo'],
        heading: {
          options: [
            {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
            {model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'},
            {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'},
            {model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3'}
          ]
        }
      },
    }
  },

  mounted() {
    this.new_subject = ""
    this.init_to_groups()
  },

  watch: {

    subject: function(newVal, oldVal) { // watch it
      this.new_subject = newVal
    },

    new_subject: function(newVal, oldVal) { // watch it
      if (newVal.length < 1 ) {
        this.subject_invalid = true
      } else {
        this.subject_invalid = false
      }
    },

    reply_recipient: function (new_val, old_val) {
      const _this = this
      if (Object.keys(new_val).length === 0) {

      } else {
        _this.add_recipient(new_val.id, new_val.name, new_val.type)
      }
    },
  },

  methods: {

    init_to_groups: function () {
      if(this.group_id.length > 0) {
        this.to_groups = "|" + this.group_id
      }
    },

    close_message: function () {
      this.message = null;
    },

    add_recipient: function (id, name, type) {
      let _this = this

      _this.recipients = []
      _this.recipient = ""

      if (type === 'user') {
        _this.to_members = _this.to_members + '|' + id
      } else {
        _this.to_groups = _this.to_groups + '|' + id
      }

      let new_recipient = {
        id: id,
        name: name,
        type: type
      }

      _this.to_recipients.push(new_recipient)

    },

    remove_recipient: function (id, type) {
      const _this = this
      _this.to_recipients.forEach((recipient, index) => {
        if (recipient.id == id) {
          _this.to_recipients.splice(index, 1)
          if (type == 'user') {
            _this.to_members = _this.to_members.replace("|" + id, "")
          } else {
            _this.to_groups = _this.to_groups.replace("|" + id, "")
          }

          return 1
        }
      })

    },

    find_recipients: function () {
      let _this = this
      let query = ""

      query = _this.recipient.trim();
      const url = moduleDir + '/dlnkmessages/actions/find_recipients.php?q=' + query

      axios({
        method: 'get',
        url: url,
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if (status) {
              _this.recipients = response.data.recipients
            } else {
              _this.message = response.data.error;
              _this.message_type = "alert-danger"
            }
          })
          .catch(function (response) {
            //handle error
          });
    },

    send_message: async function () {

      const _this = this;

      if (_this.to_members.length < 2 && _this.to_groups.length < 2) {
        _this.message = "Vous devez selectionner un destinataire connu"
        _this.message_type = "alert-danger"
        return 0
      }

      if (_this.new_subject.length < 1 ) {
        _this.message = "Veuillez renseigner le sujet du message"
        _this.message_type = "alert-danger"
        _this.subject_invalid = true
        return 0
      } else {
        _this.subject_invalid = false
      }

      let [secure_key, customer_id, api_url] = await get_token_2();
      api_url += "/messages.json"
      api_url += '?secure_key=' + secure_key;
      api_url += '&customer_id=' + customer_id;


      const form_element = document.getElementById("message_form");
      const form_data = new FormData(form_element);
      form_data.append('message[message]', _this.new_message);
      form_data.append('message[to_groups]', _this.to_groups);
      form_data.append('message[subject]', _this.new_subject);

      axios({
        method: 'post',
        url: api_url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data'}
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if (status) {
              $('#new_message_modal').modal('hide')
              _this.message = "Message envoyé."
              _this.message_type = "alert-success"
              _this.new_subject = ""
              _this.init_to_groups()
              _this.to_members = ""
              _this.to_recipients = []
              _this.new_message = ""
            } else {
              _this.message = response.data.error;
              _this.message_type = "alert-danger"
            }
          })
          .catch(function (response) {
            //handle error
          })
          .then(function(response) {
            _this.subject_invalid = false
          });
    },

  },
}
</script>

<style scoped>

.dlnkmessages_recipient {
  display: inline-block;
  border: 1px solid #0049a4;
  border-radius: 10px;
  margin-top: 2px;
  padding-left: 8px;
  padding-right: 8px;
  margin-right: .33em;
}

</style>
